import { Platform } from 'react-native'
import * as AuthSession from 'expo-auth-session'
import * as Crypto from 'expo-crypto'
import * as Random from 'expo-random'
import { Buffer } from 'buffer'
import URLEncode from '@lib/utils/URLEncode'
import env from '@lib/env'

const AUTH0_DOMAIN = env().AUTH0_DOMAIN
const AUTH0_CLIENT_ID = env().AUTH0_CLIENT_ID

export const AUTH0_BASE_URL = `https://${AUTH0_DOMAIN}`
export const AUTH0_AUTHORIZATION_REQUEST_URL = `${AUTH0_BASE_URL}/authorize`
export const AUTH0_LOGOUT_REQUEST_URL = `${AUTH0_BASE_URL}/v2/logout`
export const AUTH0_OAUTH_DEVICE_CODE_URL = `${AUTH0_BASE_URL}/oauth/device/code`
export const AUTH0_OAUTH_TOKEN_URL = `${AUTH0_BASE_URL}/oauth/token`
export const AUTH0_USERINFO_URL = `${AUTH0_BASE_URL}/userinfo`

export const Proxy = Platform.select({ web: false, default: true })
export const redirectUri = AuthSession.makeRedirectUri({ useProxy: Proxy })

async function sha256 (buffer: any): Promise<string> {
  return await Crypto.digestStringAsync(
    Crypto.CryptoDigestAlgorithm.SHA256,
    buffer,
    { encoding: Crypto.CryptoEncoding.BASE64 },
  )
}

export const getAuth0Options = async () => {
  /***
   * IMPORTANT! state carries vital information for graphql host resolving in
   * Auth0 rules; it's how it determines the environment the user is logging in from.
   ***/
  const state = env().BUILD_TARGET
  const randomBytes = await Random.getRandomBytesAsync(32)
  const base64String = Buffer.from(randomBytes).toString('base64')
  const codeVerifier = URLEncode(base64String)
  const codeChallenge = URLEncode(await sha256(codeVerifier))
  return {
    response_type: 'code',
    code_challenge: codeChallenge,
    code_challenge_method: 'S256',
    client_id: AUTH0_CLIENT_ID || '',
    redirect_uri: redirectUri,
    scope: 'openid profile email offline_access',
    state,
    code_verifier: codeVerifier,
  }
}

export const AUTH_ISSUER_CONFIG = {
  authorizationEndpoint: AUTH0_AUTHORIZATION_REQUEST_URL,
}

export const LOGOUT_SESSION_CONFIG = {
  authUrl: `${AUTH0_LOGOUT_REQUEST_URL}?client_id=${
    AUTH0_CLIENT_ID || ''
  }&returnTo=${redirectUri}`,
  returnTo: redirectUri,
}
